export var Status;
(function (Status) {
    Status["AVAILABLE"] = "AVAILABLE";
    Status["UNAVAILABLE"] = "UNAVAILABLE";
    Status["NON_WORKING_HOURS"] = "NON_WORKING_HOURS";
})(Status || (Status = {}));
export var TableConflictType;
(function (TableConflictType) {
    TableConflictType["UNKNOWN"] = "UNKNOWN";
    TableConflictType["TABLE_RESERVED"] = "TABLE_RESERVED";
    TableConflictType["TABLE_TOO_BIG"] = "TABLE_TOO_BIG";
    TableConflictType["TABLE_TOO_SMALL"] = "TABLE_TOO_SMALL";
    TableConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableConflictType || (TableConflictType = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["PARTY_PACING"] = "PARTY_PACING";
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
//# sourceMappingURL=types.impl.js.map